import React, { useEffect, useState, useCallback } from 'react'
import { Box, Typography, Divider, Paper, Grid, Card, CardContent, CardActions, Button, Chip } from '@mui/material';
import Modal from 'components/Modal';
import { useSnackbar } from 'notistack';
import LibrarySelect from 'components/librarySelect';
import { getLibraryBookingDetails } from 'services/bookings';
import IssueDetails from './IssueDetails';
import { getIssuesByProperty } from 'services/issues';

const Complaints = () => {

  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [complaints, setComplaints] = useState([]);
  const [complaintDetails, setComplaintDetails] = useState(null);
  const [librarySelected, setLibrarySelected] = useState({});


  const onLibrarySelected = useCallback((lib) => {
    setLibrarySelected(lib);
  },[]);


  useEffect(() => {
    if(librarySelected?.libraryId){
      getAllComplaints(librarySelected.libraryId);
    }
  }, [librarySelected]);


  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal],
  )

  function getAllComplaints(propertyId) {
    getIssuesByProperty({propertyId}).then(({response, error}) => {
      if(response){
        setComplaints([...response]);
      } else {
        setComplaints([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  const onCardClick = (e, bookingId, conversations, issueCreatedBy, title) => {
    getLibraryBookingDetails({bookingId }).then(({response, error}) => {
      if(response){
        setComplaintDetails({
          bookingDetails: response,
          conversations,
          issueCreatedBy,
          title
        });
        setOpenModal(true);
      } else {
        setComplaintDetails({});
        setOpenModal(false);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={4} >
          <Grid item xs={6} sm={6} md={6} xl={4} lg={4}>
            <Typography component="h2" variant="h6" color="secondary"  gutterBottom sx={{mb: 1}}>
              Complaints
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6} md={6} xl={8} lg={8}  sx={{display: 'flex'}} justifyContent="flex-end">
            <LibrarySelect onLibrarySelected={onLibrarySelected}/>
          </Grid>
        </Grid>
        <Divider />
        <Grid container columnSpacing={4} rowSpacing={4} sx={{mt: 1 }}  justifyContent="flex-start" >
          {complaints.map((complaint, index) =>(
            <Grid item xs={12} sm={6} md={6} xl={3} lg={4} key={index}>
              <Card sx={{ maxWidth: 345 }}>
                <CardContent sx={{backgroundColor: '#f8f8f8'}}>
                  <Typography gutterBottom variant="subtitle2" component="div" noWrap>
                    {complaint.summary}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {complaint.createdOn}
                  </Typography>
                </CardContent>
                <CardActions sx={{justifyContent: 'space-between'}}>
                  <Chip size="small" label={complaint.resolved ? 'Closed' : 'Open'} color={complaint.resolved ? 'success' : 'warning'}/>
                  <Button size="small" color="info"  sx={{textTransform: 'none'}} onClick={(e) => onCardClick(e, complaint.bookingId, complaint.conversations, complaint.createdBy, complaint.summary)}>
                    Details
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Modal maxWidth={"sm"} open={openModal} onModalClose={onModalClose} title={complaintDetails?.title}>
        <IssueDetails  complaintDetails={complaintDetails} />
      </Modal>
    </Paper>
  );
}
 
export default React.memo(Complaints);
